import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Label }              from "semantic-ui-react";
import MailSend                     from "../../../domain/mail/send/MailSend";
import MailSendRepository           from "../../../domain/mail/send/MailSendRepository";
import { ResKaState }               from "../../../index";
import MailSendDataSource           from "../../../infrastructure/datasource/mail/send/MailSendDataSource";
import ValidatorMessage             from "../message/ValidatorMessage";

const MailSendDestination: FC = () => {
  const mailSend: MailSend = useSelector((state: ResKaState) => state.mailSend);
  const repository: MailSendRepository = new MailSendDataSource(useDispatch());

  return (
    <>
      <Form>
        <Form.Field required>
          <label>宛先</label>
          {
            mailSend.mailGroups.isEmpty() && mailSend.customers.isEmpty()
              ?
              <p>選択されていません。</p>
              :
              <>
                {
                  mailSend.customers.toList().map(customer => (
                    <Label
                      removeIcon="delete"
                      onRemove={ () => repository.setMailSendCustomers(mailSend.customers.remove(customer)) }
                      content={
                        customer.detail.number.value === ""
                          ?
                          `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }`
                          :
                          `${ customer.detail.number.value }:${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }`
                      }
                    />
                  ))
                }
                {
                  mailSend.mailGroups.toList().map(mailGroup => (
                    <Label
                      removeIcon="delete"
                      onRemove={ () => repository.setMailSendGroups(mailSend.mailGroups.remove(mailGroup)) }
                      content={ `${ mailGroup.name.value }` }
                    />
                  ))
                }
              </>
          }
          <ValidatorMessage target="sendTargetValid"/>
        </Form.Field>
      </Form>
    </>
  );
};

export default MailSendDestination;
